// extracted by mini-css-extract-plugin
module.exports = {"selectPlan":"selectPlan___34xYi","OfferContent":"OfferContent___2l4o1","footer":"footer___3WZar","pagination":"pagination___1zSBH","footerBtn":"footerBtn___1nsV8"};